"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _slateReact = require("slate-react");
var _DropUpMenu = _interopRequireWildcard(require("../common/DropUpMenu/DropUpMenu"));
var _SlateUtils = require("../MailEditor/SlateUtils");
var _constants = require("../../utils/constants");
require("./StylesGallery.scss");
var _IconButton = _interopRequireDefault(require("../common/IconButton/IconButton"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var StylesGallery = function StylesGallery(_ref) {
  var id = _ref.id;
  var editor = (0, _slateReact.useSlate)();
  var onFontChange = function onFontChange(font) {
    _SlateUtils.UINEditor.toggleMark(editor, 'font', font);
  };
  var onColorChange = function onColorChange(color) {
    _SlateUtils.UINEditor.toggleMark(editor, 'color', color);
  };
  var onSizeChange = function onSizeChange(size) {
    _SlateUtils.UINEditor.toggleMark(editor, 'size', size);
  };
  var onTextAlignChange = function onTextAlignChange(align) {
    _SlateUtils.UINEditor.toggleAlign(editor, align);
  };
  var onToggleList = function onToggleList(type) {
    if (!_slateReact.ReactEditor.isFocused(editor)) _slateReact.ReactEditor.focus(editor);
    _SlateUtils.UINEditor.toggleType(editor, type);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-sg-container"
  }, /*#__PURE__*/_react["default"].createElement(_DropUpMenu["default"], {
    orientation: "vertical",
    text: _SlateUtils.UINEditor.currentMark(editor, 'font') || 'Arial',
    id: 'uin-sg-font-' + id
  }, Object.entries(_constants.FONTS).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      name = _ref3[0],
      val = _ref3[1];
    return /*#__PURE__*/_react["default"].createElement(_DropUpMenu.Option, {
      key: name,
      selected: _SlateUtils.UINEditor.isMarkActive(editor, 'font', name),
      style: {
        fontFamily: val
      },
      onClick: function onClick() {
        return onFontChange(name);
      }
    }, name);
  })), /*#__PURE__*/_react["default"].createElement(_DropUpMenu["default"], {
    orientation: "vertical",
    icon: "font-size",
    id: 'uin-sg-size-' + id
  }, Object.entries(_constants.FONT_SIZES).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      size = _ref5[0],
      val = _ref5[1];
    return /*#__PURE__*/_react["default"].createElement(_DropUpMenu.Option, {
      key: size,
      selected: _SlateUtils.UINEditor.isMarkActive(editor, 'size', val),
      onClick: function onClick() {
        return onSizeChange(val);
      }
    }, size);
  })), /*#__PURE__*/_react["default"].createElement(_DropUpMenu["default"], {
    orientation: "palette",
    icon: "font-color",
    iconData: _SlateUtils.UINEditor.currentMark(editor, 'color'),
    id: 'uin-sg-color-' + id
  }, Object.entries(_constants.COLORS).map(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
      name = _ref7[0],
      val = _ref7[1];
    return /*#__PURE__*/_react["default"].createElement(_DropUpMenu.Option, {
      key: name,
      selected: _SlateUtils.UINEditor.isMarkActive(editor, 'color', val),
      style: {
        backgroundColor: val
      },
      onClick: function onClick() {
        return onColorChange(val);
      }
    });
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "uin-sg-separator"
  }), /*#__PURE__*/_react["default"].createElement(_DropUpMenu["default"], {
    orientation: "horizontal",
    icon: 'text-align-' + (_SlateUtils.UINEditor.activeAlign(editor) || 'left'),
    id: 'uin-sg-align-' + id
  }, Object.values(_constants.TEXT_ALIGN).map(function (align) {
    return /*#__PURE__*/_react["default"].createElement(_DropUpMenu.Option, {
      key: align,
      icon: 'text-align-' + align,
      selected: _SlateUtils.UINEditor.isAlignActive(editor, align),
      onClick: function onClick() {
        return onTextAlignChange(align);
      }
    });
  })), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    icon: "numbered-list",
    secondary: true,
    active: _SlateUtils.UINEditor.isTypeActive(editor, _constants.LIST_TYPES[0]),
    onClick: function onClick() {
      return onToggleList(_constants.LIST_TYPES[0]);
    }
  }), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    icon: "list",
    secondary: true,
    active: _SlateUtils.UINEditor.isTypeActive(editor, _constants.LIST_TYPES[1]),
    onClick: function onClick() {
      return onToggleList(_constants.LIST_TYPES[1]);
    }
  }));
};
var _default = exports["default"] = StylesGallery;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/StylesGallery/StylesGallery.js
// module id = 1424
// module chunks = 0